var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F0E1CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.1666C14.4727 12.1666 15.6665 10.9728 15.6665 9.50016C15.6665 8.02754 14.4727 6.83374 13 6.83374C11.5274 6.83374 10.3336 8.02754 10.3336 9.50016C10.3336 10.9728 11.5274 12.1666 13 12.1666Z",
    stroke: "#0F0F0F",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6662 19.1663V17.833C17.6662 17.1259 17.3853 16.4477 16.8852 15.9476C16.3852 15.4476 15.707 15.1666 14.9998 15.1666H11.0002C10.293 15.1666 9.61477 15.4476 9.11472 15.9476C8.61467 16.4477 8.33374 17.1259 8.33374 17.833V19.1663",
    stroke: "#0F0F0F",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.c47a024696a22cb4865083db7186cf73.svg";
export { ForwardRef as ReactComponent };